import { useObserver } from "mobx-react";
import { FaCircleNotch } from "react-icons/fa";
import uploading from "../../assests/uploading.gif";
import Saving from "../../assests/storing.gif";
import Sorting from "../../assests/sorting.gif";
import Fetching from "../../assests/fetching.gif";
import { useEffect, useState } from "react";

const CircularProgressBar = ({ percentage }) => {
  const radius = 80; // Radius of the circle
  const strokeWidth = 7; // Thickness of the progress bar
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <svg
      className="absolute top-0 left-0"
      height={radius * 2}
      width={radius * 2}
    >
      {/* Background Circle */}
      <circle
        stroke="#e5e7eb" // Light gray for background
        fill="transparent"
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      {/* Progress Circle */}
      <circle
        stroke="#FF6B00" // Blue for progress
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        style={{ transition: "stroke-dashoffset 0.35s ease" }}
        transform={`rotate(${270} ${radius} ${radius})`}
      />
    </svg>
  );
};

export default function UploadLoader(props) {
  const [percentage, setPercentage] = useState(props.save ? 33 : 50);
  useEffect(() => {
    if (props.mess === "Sorting") {
      const interval = setInterval(() => {
        setPercentage((prevPercentage) =>
          props.len < 20
            ? props.save
              ? prevPercentage + 1.65
              : prevPercentage + 1.25
            : props.save
            ? prevPercentage + 0.55
            : prevPercentage + 0.416666667
        );
      }, 1000);
      return () => clearInterval(interval);
    }
    if (props.mess === "Fetching") {
      const interval = setInterval(() => {
        setPercentage((prevPercentage) =>
          props.save ? prevPercentage + 3.3 : prevPercentage + 2.5
        );
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [props.mess]);
  return useObserver(() => {
    return (
      props.load && (
        <div
          id="defaultModal"
          tabIndex="-1"
          className="overflow-y-auto overflow-x-hidden backdrop-filter backdrop-blur-sm  bg-black bg-opacity-5  fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-full inset-0 lg:h-full flex justify-center items-center"
          aria-modal="true"
          role="dialog"
        >
          <div className="flex flex-col items-center justify-center bg-white w-[80%] md:w-[20vw] rounded-lg h-[40vh] fixed z-50">
            <div className="relative w-40 h-40 flex items-center justify-center">
              {/* Circular Progress Bar */}
              <CircularProgressBar
                percentage={
                  props.mess === "Sorting" || props.mess === "Fetching"
                    ? percentage
                    : props.count
                }
              />
              {/* Image */}
              <img
                src={
                  props.mess === "Uploading" 
                    ? uploading
                    : props.mess === "Saving" || props.mess === "Updating"
                    ? Saving
                    : props.mess === "Fetching"
                    ? Fetching
                    : props.mess === "Sorting"
                    ? Sorting
                    : ""
                }
                alt="uploading"
                className="w-full h-full p-6 rounded-full object-cover"
              />
            </div>
            <h1 className="mt-4 text-gray-700 font-bold">{props.mess}... </h1>
            <p>
              {props.mess === "Sorting" || props.mess === "Fetching"
                ? percentage.toFixed(0)
                : props.count}
              %
            </p>
          </div>
        </div>
      )
    );
  });
}
